import  {createCookie} from './cookie.js'
//import asProgress from 'jquery-asProgress'

function fadeLoader() {
  jQuery('body').animate({'opacity': 1});
  jQuery('.preloader').delay(500).fadeOut(1000, function (){
    jQuery('.preload').delay(400).fadeOut(600)
  });
}

jQuery(document).ready(function($) {
  //if (jQuery('.progress').length <= 0) {
    jQuery('body').animate({'opacity': 1});
  // } else {
  //   jQuery('.progress').asProgress({
  //     namespace: 'progress',
  //     speed: 40,
  //   }).asProgress('start');

  //   jQuery('.progress').on('asProgress::finish', function (e) {
  //     fadeLoader()
  //   });
  //   jQuery(window).load(function(){
  //     jQuery('.progress').delay(1400).fadeIn(function(){
  //       jQuery(this).asProgress('finish');
  //       fadeLoader();
  //       createCookie('visited', 'visited');
  //     });
  //   });
  // }
});


// WEBPACK FOOTER //
// ./resources/assets/js/partial/preload.js